import src from "IMAGE";
export default { src, width: 120, height: 120, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAALElEQVR42r2KsQkAQAjE/OoVxWWs3X8tuV5LDQRShOiUx+oJ0e3wxQJOwxIFtkABXwrMcK4AAAAASUVORK5CYII="};
